import { APISampleAppModel, TemplateName } from "../API/AppTemplateModel"
import { SampleAppMetadata } from "../DataProgram/TemplateMetadata"

/**
 * Onboarding stages.
 * Note that changing these numbers can cause
 * analytics results to be inconsistent.
 */
export enum TemplateInstantiateStage {
    orgChoose = "org-choose",
    createJob = "add-data",
    setParameters = "configure",
    setUser = "register",
    loginUser = "login",
    polling = "loading-data",
    selectLabeler = "select-labeler",
    prepareLabeling = "prepare-labeling",
    selectProject = "select-project"
}

export interface TemplateInstantiation {
    id: string
    templateIdentifier: TemplateName
    templateTitle: string
    paramsRenderId: string
    inputDataRenderId: string
    instanceID?: string
    jobAttempts: (string | undefined)[]
    demo: boolean
    canoticCrowd: boolean
    submittingJob?: boolean
    selectedSampleAppIdentifier?: string
    sampleApps?: SampleAppMetadata[]
    sampleAppDataEntries: { [identifier: string]: APISampleAppModel }
    /**
     * Needs to be set if user is creating app in an organization.
     * Otherwise, this can remain undefined.
     */
    orgUsername?: string
    aiWorkflow: boolean
    isAppParamsNull: boolean
}
